<template>
  <v-container fluid>
    <v-card outlined :loading="settingsLoading" :disabled="settingsLoading">
      <v-container>
        <v-card-title class="justify-center">{{ $t("order.searchAnOrder") }}</v-card-title>
        <span v-show="!settingsLoading">
          <v-card-text>{{ $t("order.textForSearchingAnOrder") }}</v-card-text>
          <search-order-form @confirm="list" :loadingData="loadingData"/>
        </span>
      </v-container>
      <v-data-table
        :headers="headers"
        :items="orders"
        :loading="loadingData"
        :server-items-length="totalOrders"
        :loading-text="$t('order.ordersLoading')"
        :no-data-text="$t('order.noOrders')"
        mobile-breakpoint="768"
        v-show="!newInstance"
        :footer-props="footerProps"
        :options.sync="options"
        item-key="order_id"
        :header-props='headerProps'
      >
      <template v-slot:top><v-card-text class="text-center"> {{$t('order.searchOrdersListMessage')}} </v-card-text></template>
      <template v-slot:item.date="{ item }">
        <span>{{new Date(item.date)| moment("DD/MM/YYYY HH:mm:ss")}}</span>
      </template>
      <template v-slot:item.current_status="{ item }">
        <span>{{getStatusTranslation(item.current_status)}}</span>
      </template>
      <template v-slot:item.customer="{ item }">
        <span>{{ item.customer.last_name }} {{ item.customer.first_name }}</span>
      </template>
      <template v-slot:item.quantity="{ item }">
        <span>{{ getNbProducts(item) }}</span>
      </template>
      <template v-slot:item.total_price="{ item }">
        <span>{{ item.total_price | formatPrice(item.currency)}} {{item.currency ? item.currency.code : item.currency_code }}</span>
      </template>
        <template v-slot:item.oms_order="{ item }">
          <v-icon
          >
            {{ item.oms_order === false ?  'mdi-close' : 'mdi-check'}}
          </v-icon>
        </template>
      <template v-slot:item.action="{ item }">
          <span>
            <v-btn
                text color="primary" @click="viewDetails(item.order_id)" :class="[$vuetify.breakpoint.width >= 768? '': 'pr-0']">
              {{ $t("order.viewDetails") }}
            </v-btn>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import {EventBus} from "../../event-bus";
import {mapState} from 'vuex';
import SearchOrderForm from "@/components/orders/SearchOrderForm.vue";

export default {
  name: "GlobalSearchOrder",
  components: {
    SearchOrderForm,
  },
  data() {
    return {
      numOrder: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      phonePrefix: "",
      dateTo: undefined,
      dateFrom: undefined,
      orders: [],
      loadingData: false,
      options: {
        itemsPerPage: 15
      },
      totalOrders: 0,
      newInstance: true,
      searchOrderAccess: false,
      settingsLoading: false,
      displayFieldSettings: null
    };
  },
  computed: {
    ...mapState(['roleRights', 'roles','currentStoreDetails', 'isOctipasAdmin']),
    footerProps () {
      return {
        "items-per-page-options": [15, 30, 50],
        "items-per-page-text": this.$t("order.ordersPerPage")
      }
    },
    headerProps() {
      return {
        sortByText: this.$t("order.sortByText")
      }
    },
    headers(){
      let headers = [
        {
          text: this.$t("order.numOrder"),
          value: "order_id",
        },
        {
          text: this.$t("order.date"),
          value: "date",
        }
      ]

      if (this.addToHeaders(this.displayFieldSettings, 'customer_name', this.roles[0])) {
        headers.push(
          {
            text: this.$t('order.client'),
            value: 'customer',
            sortable: false
          })
      }

      headers.push({
          text: this.$t("order.status"),
          value: "current_status",
          sortable: false
        },
        {
          text: this.$t("order.quantity"),
          value: "quantity",
          sortable: false
        },
        {
          text: this.$t("order.amount"),
          value: "total_price",
          sortable: false
        },
        {
          text: "",
          value: "action",
          sortable: false
        })
      return headers
    },
    statusTranslations() {
      return [
        { text: this.$t("order.waiting"), value: "waiting" },
        { text: this.$t('order.waitingPayment'), value:'waiting_payment' },
        { text: this.$t("order.confirmed"), value: "confirmed" },
        { text: this.$t("order.partiallyConfirmed"), value: "partially_confirmed" },
        { text: this.$t("order.toPickup"), value: "to_pickup" },
        { text: this.$t('order.waitingCarrier'), value:'waiting_carrier' },
        { text: this.$t("order.shippingInProgress"), value: "shipping_in_progress"},
        { text: this.$t("order.partialShippingInProgress"), value: "partial_shipping_in_progress" },
        { text: this.$t("order.delivered"), value: "delivered" },
        { text: this.$t("order.deliveredPartially"), value: "partially_delivered" },
        { text: this.$t("order.cancelled"), value: "cancelled" },
        { text: this.$t("order.waitingAllocation"), value: "waiting_allocation" }
      ]
    }
  },
  async activated(){
    await this.getOrderSettings()
    if(!this.searchOrderAccess) {
      EventBus.$emit("displaySnackbar",{
        display: true,
        color: 'error',
        text: this.$t("views.unauthorized"),
      })
      await this.$router.push("/")
    }
  },
  methods: {
    getNbProducts(item) {
        // get number of items
        let nbProduct = 0;

        if (item.items){
          for (let product of item.items) {
            nbProduct += product.product_quantity;
          }
        }

        return nbProduct;
    },
    list(values) {
      this.order = []
      this.loadingData = true;
      const { page, itemsPerPage, sortDesc, sortBy } = this.options
      let myInit = {
        headers: {
          Authorization: "Bearer " + this.$auth.accessToken,
        },
        queryStringParameters: {
          items_per_page: itemsPerPage,
          sort_by: sortBy.length === 0 ? "date" : sortBy,
          sort_desc: sortDesc.length === 0 ? true : sortDesc,
          page: page,
        }
      }

      if(values) {
        this.numOrder = values.numOrder ? values.numOrder : undefined
        this.firstName = values.firstName ? values.firstName : undefined
        this.lastName = values.lastName ? values.lastName : undefined
        this.email = values.email ? values.email : undefined
        this.dateTo = values.dateTo ? values.dateTo : undefined
        this.dateFrom = values.dateFrom ? values.dateFrom : undefined
        this.phone = values?.phone?.number ? values.phone.number : undefined
        this.phonePrefix = values?.phone?.prefix && this.phone  ? values.phone.prefix : undefined
      }

      myInit.queryStringParameters.order_id = this.numOrder
      myInit.queryStringParameters.first_name = this.firstName
      myInit.queryStringParameters.last_name = this.lastName
      myInit.queryStringParameters.email = this.email
      myInit.queryStringParameters.date_from = this.dateFrom
      myInit.queryStringParameters.date_to = this.dateTo
      myInit.queryStringParameters.phone = this.phone
      myInit.queryStringParameters.phone_prefix = this.phonePrefix

      this.$Amplify.API.get("orders", "/v1/int/orders/search", myInit)
        .then((res) => {
          this.newInstance = false
          this.orders = res.data
          this.totalOrders = res.nb_sub_orders
          this.loadingData = false;
          if(this.totalOrders < ((this.options.page - 1) * this.options.itemsPerPage) + 1){
            let pageNumber = Math.floor(this.totalOrders / this.options.itemsPerPage)
            this.options.page = pageNumber === 0 ? 1 : pageNumber
          }
        })
        .catch((e) => {
          this.orders = []
          this.loadingData = false;
          console.log(e);
          EventBus.$emit("displaySnackbar", {
            display: true,
            text: this.$t("subOrder.ordersLoadingErrorMessage"),
            color: "error",
          });
        });
    },
    getStatusTranslation: function(statusValue) {
      let status = this.statusTranslations.find(status => status.value == statusValue);
      if (status) {
        return status.text;
      } else return statusValue;
    },
    viewDetails(orderId) {
      this.$router.push("/seller-orders/" + orderId);
    },
    async getOrderSettings(){
      let countryCode = this.currentStoreDetails?.address?.country_id
      this.settingsLoading = true
      let myInit = {
        headers: {
          "Authorization": 'Bearer ' + this.$auth.accessToken
        }
      }
      try {
        let res = await this.$Amplify.API.get("settings", "/v1/settings/" + countryCode, myInit)
        this.searchOrderAccess = Array.isArray(res.display?.display_orders_global_search)
            && this.roles.some(role => res.display.display_orders_global_search.includes(role))
        this.displayFieldSettings = res.display?.customer_information
        this.settingsLoading = false
      } catch (e) {
        this.settingsLoading = false
        console.log(e)
      }
    }
  },
  watch: {
    options: {
      handler() {
        //we don't want to list if there isn't any of the mandatory field set
        if (this.numOrder || (this.firstName && this.lastName) || this.email) {
          this.list()
        }
      }
    },
  }
};
</script>
